'use memo'

import { useFormikContext } from 'formik'
import { capitalizeWords } from '@sportninja/common/ts-utils'
import {
  PLUGIN_ALIGN_OPTIONS,
  type PluginAlign,
  type PluginEmbedSettings,
} from '@sportninja/common/features/account/apiAccess'
import { SegmentedInput } from 'src/components/ts-components/SegmentedInput'
import { NumberField } from '../../../components/FormikField'
import { PLUGIN_BASE_MAX_WIDTH } from '../../constants/pluginSettings'
import { SettingSwitch } from './SettingSwitch'

const ALIGN_OPTIONS = PLUGIN_ALIGN_OPTIONS.map(({ label, value }) => ({
  label: capitalizeWords(label),
  value,
}))

/** The plugin card's size, border and place (the snippet's `display` options). */
export const ThemeLayout = () => {
  const { values, setFieldValue } = useFormikContext<PluginEmbedSettings>()
  const { hideBorder, align } = values.display

  return (
    <>
      <NumberField
        name='display.maxHeight'
        label={capitalizeWords('Max Height (px)')}
        placeholder={capitalizeWords('Auto')}
        hint='Auto grows with the content. Set: the plugin scrolls inside instead of growing taller'
        emptyValue='null'
      />
      <NumberField
        name='display.maxWidth'
        label={capitalizeWords('Max Width (px)')}
        placeholder={PLUGIN_BASE_MAX_WIDTH}
        hint={`The plugin never grows wider than this; ${PLUGIN_BASE_MAX_WIDTH} px by default`}
        emptyValue='null'
      />
      <SettingSwitch
        label={capitalizeWords('Show Border')}
        hint='The line around the whole plugin'
        checked={!hideBorder}
        onChange={(shown) => setFieldValue('display.hideBorder', !shown)}
      />
      <SegmentedInput
        label={capitalizeWords('Alignment')}
        options={ALIGN_OPTIONS}
        value={align ?? 'center'}
        onChange={(next: PluginAlign) =>
          setFieldValue('display.align', next === 'center' ? null : next)
        }
      />
    </>
  )
}
